<template>
  <v-container grid-list-xs>
    <h1>Home</h1>
  </v-container>
</template>

<script>
// @ is an alias to /src

export default {
  components: {
    //
  },
};
</script>
